import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Loader from './Loader';
import { toast } from 'react-toastify';

const AdminRoute = ({ children }) => {
  const { isLoggedIn, authChecked, user } = useAuth();

  useEffect(() => {
    if (!authChecked) return;
    if (!isLoggedIn) {
      toast.error('Unauthorized access. Please log in first.');
    } else if (isLoggedIn && user?.role !== 'admin') {
      toast.error('Admin access required.');
    }
  }, [authChecked, isLoggedIn, user]);

  if (!authChecked) return <Loader />;
  if (!isLoggedIn) return <Navigate to="/login" replace />;
  if (user?.role !== 'admin') return <Navigate to="/unauthorized" replace />;

  return children;
};

export default AdminRoute;
